import { useNavigate } from "react-router-dom";

const BackButton = ({ className, onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick(); // Utiliser la fonction personnalisée si elle est fournie
    } else {
      navigate(-1); // Comportement par défaut (revenir en arrière)
    }
  };

  return (
    <img
      src="/back.png"
      className={`d-flex align-items-center ${className}`}
      onClick={handleClick}
      style={{ cursor: "pointer" }}
      alt="BackButton"
    />
  );
};

export default BackButton;
